import { Injectable } from '@angular/core';
import { ToastrService, Toast } from 'ngx-toastr';
import { NotificationToastComponent } from '../notification-toast/notification-toast.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService { 

  private notificationsCounter: number = 0;

  constructor(private toastr: ToastrService) { } 

  showFetrapiNotification(message: string, notificationId: string) { 

    this.toastr
      .show(message, undefined, {
        disableTimeOut: true,
        tapToDismiss: false,
        closeButton: true,
        toastComponent: NotificationToastComponent,
        // @ts-ignore
        notificationId: notificationId, 
      });
  }

  showFetrapiMessage(message: string) {
    this.toastr
      .error(message, undefined, {
        disableTimeOut: false,
        tapToDismiss: true,
        closeButton: true,
        toastComponent: Toast,
        positionClass: 'toast-bottom-right' 
      });
  }

  clearAllNotifications() {
    this.toastr.clear();
  }

  public updateNotificationsCounter(notifications: number, all: boolean): void {
    this.notificationsCounter = all ? notifications : this.notificationsCounter + notifications; 
  }

  getNotificationsCounter(): number {
    return this.notificationsCounter;
  }

}
